import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "app-time-picker",
  templateUrl: "./time-picker.component.html",
  styleUrls: ["./time-picker.component.scss"],
  standalone: false,
})
export class TimePickerComponent {
  @Input() placeholder: any;
  @Input() label: any;
  @Input() class = "";
  @Input() isFormSubmitted: boolean = false;
  @Input() readOnly: boolean = false;
  @Input() format: string = "h:mm:ss a";
  @Input() use12HoursFormat: boolean = true;
  @Input()
  set control(control: FormControl) {
    this._control = control;
    this.onControlChange$.next();
  }
  get control(): FormControl {
    return this._control;
  }
  private _control: FormControl = new FormControl();

  private onControlChange$: Subject<void> = new Subject();
  @Output()
  valueChanges = new EventEmitter<any>();
  constructor() {
    this.onControlChange$.subscribe(() => {
      this.control.valueChanges
        .pipe(takeUntil(this.onControlChange$))
        .subscribe(() => this.valueChanges.emit(this.control.value));
    });
    this.onControlChange$.next();
  }

  // ngOnInit(): void { }
  ngOnChanges(changes: SimpleChanges) {
    if (changes["isFormSubmitted"]) {
      this.isFormSubmitted = changes["isFormSubmitted"].currentValue;
    }
  }
}
